import { Flex, MenuList } from "@chakra-ui/react"
import { filterConstants } from "../../../../../../../common/constants/search-constants"
import { FhResponseData } from "../../../../../../../common/types/search"
import { isFilterOptionToBeRemoved } from "../../../../../../../common/utils/search-utils"
import CheckboxListForm from "../CheckboxListForm/CheckboxListForm"
import RadioListForm from "../RadioListForm/RadioListForm"
import ToggleFilterForm from "../ToggleFilterForm/ToggleFilterForm"
import TypeHeadSearch from "../TypeHeadSearch/TypeHeadSearch"

type Props = {
  filterData: FhResponseData
  breadcrumbFilters: FhResponseData
  showFiltersNoResultsView: boolean
  handleOnClose: () => void
  isOverlayFilters?: boolean
  closeFiltersOverlay?: () => void
  rid: string
}

const FilterOptions = ({
  filterData,
  breadcrumbFilters,
  showFiltersNoResultsView,
  handleOnClose,
  isOverlayFilters,
  closeFiltersOverlay,
  rid,
}: Props) => {
  const { filtersection, display_hint, url_params_base, on, basetype } = filterData
  const isBasetypeSetOrList = basetype === filterConstants.SET || basetype === filterConstants.LIST

  /* Remove filter if nr is 0 or basetype is set or list and name === value
   Comment from PBI why we have the second check: Fredhopper expects to have translations for all created value IDs per product
   in all locales and at the moment thats not the case, so we hide them for now */
  const filteredFiltersection = filtersection.filter(
    (filterOption: FhResponseData) =>
      !isFilterOptionToBeRemoved(filterOption, isBasetypeSetOrList, showFiltersNoResultsView)
  )

  /* With FH custom type they want to be able to disable search bar manually */
  const isSearchDisabledByCustomType = (() => {
    const searchDisabledCustomType = filterData?.custom_fields?.custom_field?.find(
      (field: FhResponseData) =>
        field.name === filterConstants.DISABLE_SEARCH_BAR && field.value === filterConstants.YES
    )

    return !!searchDisabledCustomType
  })()

  const getCustomFieldTypeOfFormValue = () => {
    const visualisationType = filterData?.custom_fields?.custom_field?.find(
      (field: FhResponseData) => field.name === filterConstants.VISUALISATION_TYPE
    )

    if (visualisationType?.value) {
      return visualisationType.value
    }

    /* If no such custom type render checkbox_list form */
    return filterConstants.CHECKBOX_LIST
  }

  const isSearchEnabled =
    filteredFiltersection.length > filterConstants.SEARCH_ENABLED_NUMBER && !isSearchDisabledByCustomType

  const typeOfForm = getCustomFieldTypeOfFormValue()

  const WrapperType = isOverlayFilters ? Flex : MenuList

  return (
    <WrapperType
      zIndex={isOverlayFilters ? "base" : "dropdown"}
      overflowY="auto"
      maxH={isOverlayFilters ? "100%" : "96"}
      w={isOverlayFilters ? "100%" : "72"}
      pb="0"
      boxShadow={isOverlayFilters ? "none" : "md"}
      flexDirection="column"
    >
      {(typeOfForm === filterConstants.CHECKBOX_LIST || typeOfForm === filterConstants.COLOUR_TILES) && (
        <TypeHeadSearch isSearchEnabled={isSearchEnabled} filteredFiltersection={filteredFiltersection}>
          <CheckboxListForm
            filteredFiltersection={filteredFiltersection}
            display_hint={display_hint}
            url_params_base={url_params_base}
            on={on}
            isSearchEnabled={isSearchEnabled}
            basetype={basetype}
            isOverlayFilters={isOverlayFilters}
            closeFiltersOverlay={closeFiltersOverlay}
            isColourFilter={typeOfForm === filterConstants.COLOUR_TILES}
            handleOnClose={handleOnClose}
            rid={rid}
            facetId={filterData.facetid}
          />
        </TypeHeadSearch>
      )}
      {typeOfForm === filterConstants.RADIO_BUTTON && (
        <TypeHeadSearch isSearchEnabled={isSearchEnabled} filteredFiltersection={filteredFiltersection}>
          <RadioListForm
            filteredFiltersection={filteredFiltersection}
            isSearchEnabled={isSearchEnabled}
            basetype={basetype}
            breadcrumbFilters={breadcrumbFilters}
            isOverlayFilters={isOverlayFilters}
            closeFiltersOverlay={closeFiltersOverlay}
            handleOnClose={handleOnClose}
            rid={rid}
            facetId={filterData.facetid}
          />
        </TypeHeadSearch>
      )}
      {typeOfForm === filterConstants.TOGGLE && filteredFiltersection?.[0] && (
        <ToggleFilterForm
          filteredFiltersection={filteredFiltersection}
          isOverlayFilters={isOverlayFilters}
          closeFiltersOverlay={closeFiltersOverlay}
          handleOnClose={handleOnClose}
          rid={rid}
          facetId={filterData.facetid}
        />
      )}
    </WrapperType>
  )
}

export default FilterOptions
